module.exports = __webpack_public_path__ + "static/rice-logo-footer@3x-1c2d2ad6d719af6d99affb6a03a2419e.jpg";